import { render, staticRenderFns } from "./EmployeesHeaderDashboard.vue?vue&type=template&id=7e82b4d2"
import script from "./EmployeesHeaderDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesHeaderDashboard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports